import { ISearchRepository } from "../../adapters/driven/repositories/searchRepository";

export const SearchServiceImplFactory = ({
  searchRepository,
}: {
  searchRepository: ISearchRepository;
}) => {
  const getSearch: IGetSearch = async ({
    clinicId,
    floorIds,
    search,
    patientIds,
  }) => {
    try {
      const payload: Parameters<IGetSearchAPI>[0] = {
        clinic_id: clinicId,
        floor_ids: floorIds,
        consent_status: [0, 1, 2],
      };
      if (search !== undefined) {
        payload.search = search;
      } else if (patientIds && patientIds.length > 0) {
        payload.patient_ids = patientIds;
      }
      const response = await searchRepository.getSearchAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getAllPatientList: IGetAllPatientListService = async ({ clinicId }) => {
    try {
      const payload: Parameters<IGetAllPatientListAPI>[0] = {
        clinic_id: clinicId,
      };
      const response = await searchRepository.getAllPatientListAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getAllPatientListV2: IGetAllPatientListV2Service = async ({
    clinicId,
  }) => {
    try {
      const payload: Parameters<IGetAllPatientListV2API>[0] = {
        clinic_id: clinicId,
      };
      const response = await searchRepository.getAllPatientListV2API(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };
  return {
    getSearch,
    getAllPatientList,
    getAllPatientListV2,
  };
};
